import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { PersistenceService, PersistMode } from "@barthauer/abc/core/data";
import {
  AbcAccordionComponent,
  AbcDateBoxComponent,
  AbcNumberBoxComponent,
  AbcPopupComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
  _AbcTreeComponent,
} from "@barthauer/abc/ui-components";
import { Measure, MeasureTask, Property } from "@barthauer/custom/xmt-models";
import {
  DxAccordionModule,
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextBoxModule,
  DxTreeListModule,
} from "devextreme-angular";
import { forkJoin, from, map, of, Subscription, switchMap } from "rxjs";
import { CollaboratorsComponent } from "../../../customer-space/measure/measure-detail/implementation-plan/collaborators/collaborators.component";
import { MeasureService } from "../../../customer-space/measure/measure.service";
import {
  NotificationMessage,
  ROLES,
  ToastType,
} from "../../../models/enumeration-list.model";
import { DataService, ObjectKeys } from "../../../services/data.service";
import { NotificationService } from "../../../services/notification.service";
import { SharedModule } from "../../shared.module";
import {
  MilestoneTaskPopupService,
  originOfCall,
} from "../milestone-task-popup.service";
import {
  EmailNotificationDescriptions,
  EmailNotificationSubjects,
  EmailNotificationType,
  NotificationService1,
} from "../../../services/notification1.service";
import { formatMessage } from "devextreme/localization";
import { AIMSROUTES } from "../../../../app-routing.module";
import { LanguageService } from "../../../services/language.service";

@Component({
  selector: "ubt-geods-task",
  templateUrl: "./task.component.html",
  styleUrls: ["./task.component.scss"],
  imports: [
    AbcPopupComponent,
    _AbcFormComponent,
    DxTreeListModule,
    DxFormModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxButtonModule,
    SharedModule,
    _AbcButtonComponent,
    DxPopupModule,
    DxAccordionModule,
    DxDataGridModule,
    CollaboratorsComponent,
    _AbcTextAreaComponent,
  ],
  providers: [MilestoneTaskPopupService],
})
export class TaskComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("task_popup") taskPopup: AbcPopupComponent;
  @ViewChild("task_form") taskForm: _AbcFormComponent;
  @ViewChild("collaboratorGrid") collaboratorGrid: CollaboratorsComponent;
  @Input() canManageTasks: boolean;
  @Output() updateGantt = new EventEmitter<boolean>();

  public currentMeasure: Measure = new Measure(null);
  public measureTask: MeasureTask = new MeasureTask(null);
  public currentMeasureTask: MeasureTask = new MeasureTask(null);
  public measureTaskId: string;
  public ROLES: ROLES;
  public isUpdatingTask = false;
  public currentTaskResponsibleId: String;
  private origin!: string;

  public resources!: (key: string, ...value: string[]) => string;
  public task: MeasureTask = new MeasureTask(null);

  public submitButtonOptions!: any;
  public cancelButtonOptions!: any;

  public measureTaskStatus = [];

  private subscriptions: Subscription[] = [];

  constructor(
    public dataService: DataService,
    private persistenceService: PersistenceService,
    private measureService: MeasureService,
    private notificationService: NotificationService,
    private notificationService1: NotificationService1,
    public milestoneTaskPopupService: MilestoneTaskPopupService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.resources = this.dataService.res;
    this.cancelButtonOptions = {
      text: this.resources("Ubt-CreateMeasure-Cancel"),
      useSubmitBehavior: false,
      onClick: () => this.clearWindow(),
    };
    this.measureTaskStatus = [
      { name: this.resources("Ubt-Measure-Detail-Status-Open"), value: 0 },
      {
        name: this.resources("Ubt-Measure-Detail-Status-In-Progress"),
        value: 1,
      },
      { name: this.resources("Ubt-Measure-Detail-Status-Done"), value: 2 },
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentMeasure.MeasureTasks) {
      this.prepareAllowedMeasureTask();
    } else {
      this.currentMeasure.MeasureTasks = [];
    }
    this.cdr.markForCheck();
  }

  private prepareAllowedMeasureTask() {
    this.currentMeasure.MeasureTasks.sort((a, b) =>
      a.Label.localeCompare(b.Label),
    );
  }

  public onCalculateOverallTime(event): void {
    this.measureTask.TotalTimeRequired = event;
  }
  public IsRoleAuthorizedToUpdateDate(isUpdating: boolean): boolean {
    if (isUpdating) {
      return !this.dataService.hasNoMatchingRole([ROLES.Admin]);
    } else return true;
  }

  public persistMeasureSubTask(event) {
    if (this.isUpdatingTask === false) {
      event.preventDefault();
      this.persistTask(PersistMode.Insert);
    } else {
      event.preventDefault();
      this.persistTask(PersistMode.Update);
    }
  }

  private persistTask(mode: PersistMode): void {
    if (!this.currentMeasure.MeasureTasks) {
      this.currentMeasure.MeasureTasks = [];
    }

    this.subscriptions.push(
      this.persistenceService
        .executePersistObjectQuery(
          this.milestoneTaskPopupService.preparePersistTask(
            this.currentMeasure,
            this.measureTask,
            this.measureTaskId,
            mode,
          ),
        )
        .pipe(
          switchMap((task: any) => {
            if (
              mode === PersistMode.Insert ||
              (mode === PersistMode.Update &&
                this.measureTask.Responsible !== this.currentTaskResponsibleId)
            ) {
              return this.notificationService1
                .getNotificationSettings(this.measureTask.Responsible)
                .pipe(
                  switchMap((data: Property[]) => {
                    const settings =
                      this.notificationService1.parseNotificationSettings(data);
                    const inApp$ = settings.notificationInApp
                      ? this.notificationService1.createNotifications([
                          {
                            ParentId: task.Id,
                            ParentObjectType: 330001137,
                            Comment: "notification.Measure-Task-TaskAssigned",
                            Text: "",
                            UserIdList: [this.measureTask.Responsible],
                          },
                        ])
                      : of(null);

                    const email$ = settings.notificationByEmail
                      ? this.dataService
                          .readObjects(
                            ObjectKeys.PERSON,
                            [
                              this.dataService.coreDataService.createQueryColumn(
                                "EMail",
                                "EMail",
                              ),
                            ],
                            `Id='${this.measureTask.Responsible}'`,
                          )
                          .pipe(
                            switchMap((persons: any[]) => {
                              const email = persons?.[0]?.EMail;
                              if (!email) return of(null);

                              return from(
                                this.languageService.translateBulk(
                                  [
                                    {
                                      field: "subject",
                                      key: EmailNotificationSubjects.MEASURE_TASK_ASSIGNED,
                                    },
                                    {
                                      field: "description",
                                      key: EmailNotificationDescriptions.MEASURE_TASK_ASSIGNED,
                                      params: {
                                        0: this.measureTask?.Label
                                          ? this.measureTask.Label
                                          : "",
                                      },
                                    },
                                    {
                                      field: "notificationType",
                                      key: EmailNotificationType.MEASURE_TASK_ASSIGNED,
                                    },
                                  ],
                                  settings.language,
                                ),
                              ).pipe(
                                switchMap((translations) => {
                                  const redirectUrl =
                                    this.dataService.generateRedirectionUrl(
                                      AIMSROUTES.MEASURE_DETAIL,
                                      [
                                        AIMSROUTES.MEASURES,
                                        this.measureService.currentMeasure().Id,
                                      ],
                                    );
                                  const content = {
                                    notificationType:
                                      translations.notificationType,
                                    description: translations.description,
                                    redirectUrl,
                                  };
                                  return this.notificationService1.sendNotificationEmail(
                                    content,
                                    translations.subject,
                                    email,
                                    settings.language,
                                  );
                                }),
                              );
                            }),
                          )
                      : of(null);

                    return forkJoin([inApp$, email$]).pipe(map(() => task));
                  }),
                );
            }

            return of(task);
          }),
        )
        .subscribe(
          (task: any) => {
            if (mode === PersistMode.Insert) {
              if (this.measureTask.Collaborators?.length > 0) {
                this.prepareCollaborators(task.Id);
              }
              this.measureTask.Id = task.Id;
              this.measureTask = new MeasureTask(this.measureTask);

              if (this.origin === originOfCall.Gantt) {
                this.updateGantt.next(true);
              } else {
                this.currentMeasure.MeasureTasks.push(this.measureTask);
              }
              this.dataService.updateGridData(this.measureTask);
              this.cdr.markForCheck();
            } else {
              const taskIndex = this.currentMeasure.MeasureTasks.findIndex(
                (item) => item.Id === task.Id,
              );
              this.currentMeasure.MeasureTasks[taskIndex] = this.measureTask;
            }
            this.measureService.realTimecalculateTotalTime(true);
            this.clearWindow();
            this.cdr.markForCheck();
            this.notificationService.callNotification({
              message: NotificationMessage.ValidInsertMessage,
              type: ToastType.SUCCESS,
            });
          },
          (error) => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
          },
        ),
    );
  }

  public prepareCollaborators(measureTaskId: string): void {
    this.persistenceService
      .executePersistObjectsQuery(
        this.milestoneTaskPopupService.prepareCollaborators(
          this.measureTask,
          measureTaskId,
        ),
      )
      .subscribe(
        (data) => {},
        (error) => {
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
        },
      );
  }

  public showPopup(
    currentMeasure: Measure,
    measureTask: MeasureTask,
    isUpdatingTask: boolean,
    origin: originOfCall,
  ) {
    this.currentMeasure = currentMeasure;

    this.measureTask = measureTask;

    this.currentTaskResponsibleId = { ...this.measureTask }.Responsible;
    this.measureTask.Type = 1;
    this.measureTaskId = measureTask ? measureTask.Id : undefined;
    this.currentMeasureTask = measureTask;
    this.isUpdatingTask = isUpdatingTask;
    this.origin = origin;

    this.taskPopup.title = this.resources(
      "Ubt-MeasureTask-" +
        (this.isUpdatingTask ? "Update" : "Create") +
        "-Task",
    );

    this.submitButtonOptions = {
      text: this.resources(
        "Ubt-CreateMeasure-" + (this.isUpdatingTask ? "Update" : "Create"),
      ),
      useSubmitBehavior: true,
      disabled: !this.canManageTasks,
    };
    this.cdr.markForCheck();
    this.taskPopup.instance.show();
  }

  public clearWindow(clearMeasureTask: boolean = true): void {
    this.taskPopup.instance.hide();
    if (clearMeasureTask) {
      this.measureTask = new MeasureTask(null);
    }
    this.collaboratorGrid?.collaboratorGrid?.instance.cancelEditData();
    this.measureTask.Collaborators = [];
  }

  public resetValues(): void {
    this.measureTask.Collaborators = [];
    this.collaboratorGrid?.collaboratorGrid?.instance.cancelEditData();
    this.taskPopup.instance.hide();
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  public formatDate(datePipe: DatePipe, date: Date): string {
    return datePipe.transform(date, "dd.MM.yyyy HH':'mm") || "";
  }

  public addUserNameAndTimeToNotes(): void {
    const userName: string | null = sessionStorage.getItem("userName");
    const timestamp = `----- ${this.formatDate(this.datePipe, new Date())} (${userName}) -----\n\n`;
    this.measureTask.Comment = `${timestamp}${this.measureTask.Comment ?? ""}`;
  }
}
